module.exports = __webpack_public_path__ + "static/dei_itv_nick_arnaud-cf105c6e3f297aa210fce715f24433ca.png";